import { useTranslation, Trans } from "react-i18next";
import { useState } from "react";
import exchange from '../../img/InvestmentPlans/exchange.png'

function Exchange() {

  const { t } = useTranslation();

   const [openIndex, setOpenIndex] = useState(0); // первый открыт
  
    const faqs = [
      {
        q: t("investment.22"),
        a: t("investment.23"),
      },
      {
        q: t("investment.24"),
        a: t("investment.25"),
      },
      {
        q: t("investment.26"),
        a: t("investment.27"),
      }
    ]
  
    const toggle = (index) => {
      setOpenIndex(openIndex === index ? null : index);
    };

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col xl:flex-row justify-between items-start gap-[20px]">
            <div className="xl:max-w-[600px]">
                <p className="text-[20px] xl:text-[48px] poppins font-[500] text-[#061A77] xl:max-w-[465px] leading-[1.2]"><Trans>{t('investment.20')}</Trans></p>
                <p className="poppins text-[#1A0402] text-[16px] font-[500] xl:text-[20px] leading-[1.5] mt-[12px]">{t('investment.21')}</p>
                <div className="flex flex-col gap-3 mt-[20px] xl:mt-[40px]">
                    {faqs.map((item, index) => {
                        const isOpen = openIndex === index;
                        return (
                        <div
                            key={index}
                            className="bg-[#F4F7FF] rounded-[4px] overflow-hidden transition-all"
                        >
                            {/* Header */}
                            <button
                            onClick={() => toggle(index)}
                            className="w-full flex items-center justify-between px-6 py-3 text-left"
                            >
                            <span className="text-[#0A1B6F] font-medium">
                                {item.q}
                            </span>

                            <span className="flex items-center flex-shrink-0 justify-center w-6 h-6 rounded-full border border-[#0A1B6F] text-[#0A1B6F] text-sm font-bold">
                                {isOpen ? "−" : "+"}
                            </span>
                            </button>

                            {/* Content */}
                            <div
                            className={`px-6 transition-all duration-300 ease-in-out ${
                                isOpen
                                ? "max-h-[300px] opacity-100 pb-5"
                                : "max-h-0 opacity-0 pb-0"
                            }`}
                            >
                            <p className="text-[#5B6478] text-sm leading-relaxed">
                                {item.a}
                            </p>
                            </div>
                        </div>
                        );
                    })}
                </div>
            </div>
            <img src={exchange} alt="" />
        </div>
    </div>
  );
}

export default Exchange;
 